import { render, staticRenderFns } from "./AppVersionManagement.vue?vue&type=template&id=8244916c&scoped=true&"
import script from "./AppVersionManagement.vue?vue&type=script&lang=js&"
export * from "./AppVersionManagement.vue?vue&type=script&lang=js&"
import style0 from "./AppVersionManagement.vue?vue&type=style&index=0&id=8244916c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8244916c",
  null
  
)

export default component.exports